<section id="createTravelPage">
    
    <div class="px-5">
        <div *ngIf="gridOptions" class="mt-3 border-radius-15 overflow-hidden">
            <ag-grid-angular
                [rowData]="data"
                [gridOptions]="gridOptions"
                style="height: 600px; width: 100%;"
                class="ag-theme-alpine">
            </ag-grid-angular>
        </div>
        <hr>
        <!-- <div class="mt-3 border-radius-15 overflow-hidden" *ngIf="gridServerOptions">
            <ag-grid-angular
                [gridOptions]="gridServerOptions"
                (paginationChanged)="onPaginationChanged($event)"
                style="height: 600px; width: 100%"
                class="ag-theme-alpine"
            ></ag-grid-angular>
        </div> -->
          
    </div>
</section>

<!-- MODAL -->
<ng-template #theModalDetailTravel let-theModalDetailTravel let-c="close" let-d="dismiss">
    <div>
        <div class="modal-header d-flex flex-row justify-content-between align-items-center p-3 mb-3 bg-primary-custom">
            <div class="title-wrapper">
                <h5>Dettagli Viaggio</h5>
            </div>
        </div>
        <div class="modal-body container-fluid">
           <div class="row">
                
                <div class="col-12 col-lg-4 border-right-primary">
                    <div class="color-first">
                        <h6 class="text-center text-lg-start">Viaggio</h6>
                    </div>
                    <div>
                        <div class="mt-3" data-aos="fade-right" data-aos-easing="ease-out-cubic" data-aos-duration="1000">
                            <label class="color-secondary">Partenza - Arrivo</label>

                            <div>
                                <span>{{travelDetail.cittaPartenza}}</span>
                                <i class="fa-solid fa-arrow-right color-first mx-3"></i>
                                <span>{{travelDetail.cittaArrivo}}</span>
                            </div>
                        </div>
                        <div class="mt-3" data-aos="fade-right" data-aos-easing="ease-out-cubic" data-aos-duration="1000">
                            <label class="color-secondary">Giorno - Ora</label>

                            <div>
                                <span>{{travelDetail.giorno}}</span>
                                <i class="fa-solid fa-arrow-right color-first mx-3"></i>
                                <span>{{travelDetail.oraPartenza}}</span>
                            </div>
                        </div>
                        <div class="mt-3" data-aos="fade-right" data-aos-easing="ease-out-cubic" data-aos-duration="1000">
                            <label class="color-secondary">Numero di posti</label>

                            <div>
                                <span>{{travelDetail.numPosti}}</span>
                            </div>
                        </div>
                        <div class="mt-3" data-aos="fade-right" data-aos-easing="ease-out-cubic" data-aos-duration="1000">
                            <label class="color-secondary">Prezzo</label>

                            <div>
                                <span>{{formatNumInCurrency(travelDetail.contributoEconomico)}} €</span>
                            </div>
                        </div>

                        <div class="mt-3" data-aos="fade-right" data-aos-easing="ease-out-cubic" data-aos-duration="1000">
                            <label class="color-secondary">Tappe Intermedie</label>

                            <div *ngIf="!travelDetail.tappeIntermedie || travelDetail?.tappeIntermedie.length == 0">
                                <span class="color-first">Nessuna</span>
                            </div>

                            <div *ngIf="travelDetail.tappeIntermedie && travelDetail?.tappeIntermedie.length > 0">
                                <ul class="list-custom-first">
                                    <li *ngFor="let t of travelDetail.tappeIntermedie">{{t}}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-12 col-lg-8 border-left-primary mt-5 mt-lg-0">
                    <div class="color-first">
                        <h6 class="mb-3 text-center text-lg-start">Autista</h6>
                        <span> {{travelDetail.autista.nome+" "+travelDetail.autista.cognome}}</span>
                    </div>
                    <div class="autista-img" data-aos="zoom-in" data-aos-easing="ease-out-cubic" data-aos-duration="1000">
                        <img [src]="travelDetail.autista.img" [alt]="travelDetail.autista.nome">
                    </div>
                    <div title="{{travelDetail.autista.recensione}}" class="d-flex flex-column mt-4">
                        <span>Recensioni</span>
                        <div>
                            <i class="fa-solid fa-star text-warning" *ngFor="let star of generateArrayFromNumber(travelDetail.autista.recensione)"></i>
                        </div>
                    </div>
                </div>
           </div>
        </div>
        <div class="modal-footer" *ngIf="isOnlyForDetail">
            <button class="btn-first" (click)="aggiungiViaggio(travelDetail, theModalDetailTravel)">Effettua Prenotazione</button>
        </div>
    </div>
</ng-template>
